import { ref, watch, computed } from '@vue/composition-api'

import useJwt from "@/auth/jwt/useJwt";
import CISSettingService from '@/services/cis-setting.service'

import store from "@/store";

export default function cisSynonymsList() {
  const refSynonymsTable = ref(null)

  // Table Handlers
  const tableColumns = [
    { key: 'keyword', label: 'keyword', sortable: false },
    { key: 'synonym', label: 'synonym', sortable: false },
    { key: 'actions', sortable: false },
  ]
  const perPage = ref(10)
  const totalSynonyms = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const statusFilter = ref(null)
  const listCtgSq = ref(1)

  const dataMeta = computed(() => {
    const localItemsCount = refSynonymsTable.value ? refSynonymsTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalSynonyms.value,
    }
  })

  const reFetchData = () => {
    refSynonymsTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery, statusFilter], () => {
    reFetchData()
  })

  const fetchSynonyms = (ctx, callback) => {
    
    CISSettingService.synonymList({
      search: searchQuery.value,
      pageNumber: currentPage.value - 1,
      pageSize: perPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      status: statusFilter.value,
      ctgSq: listCtgSq.value
    }).then(response => {
      if (response && response.data.success) {
        const { data, total } = response.data
        callback(data)
        totalSynonyms.value = total
      }
    })
  }

  return {
    fetchSynonyms,
    tableColumns,
    perPage,
    currentPage,
    totalSynonyms,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refSynonymsTable,

    statusFilter,

    reFetchData,
    listCtgSq
  }
}
